import api from '@/plugins/api';
import { checkError, cloneDeep, prepareApiParams } from 'erp-skeleton-library/utils';

const template = {
  id: 0,
  name: null,
  order: null,
}

const state = {
  tableLoading: false,
  allPraTaskRiskPreventions: [],
  registerPraTaskRiskPrevention: {
    id: 0,
    name: null,
    order: null,
  },
  headers: [
    {
      text: 'Nome',
      align: 'left',
      value: 'name',
      sortable: false,
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allPraTaskRiskPreventions = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    state.registerPraTaskRiskPrevention = cloneDeep(payload ?? template);
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('pra/tasks/' + payload.task + '/risks/' + payload.risk + '/preventions', payload)
         .then(response => {
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let query = prepareApiParams(payload, 'id,name,order');
      state.tableLoading = true;

      api.get('pra/tasks/' + payload.task + '/risks/' + payload.risk + '/preventions?' + new URLSearchParams(query).toString())
         .then(response => {
           commit('LIST', response.data.entities);
           resolve(response.data);
         })
         .catch(error => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
  read({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get('pra/tasks/' + payload.task + '/risks/' + payload.risk + '/preventions/' + payload.id)
         .then(response => {
           commit('SET', response.data);
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('pra/tasks/' + payload.task + '/risks/' + payload.risk + '/preventions/' + payload.id, payload)
         .then(response => {
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.delete('pra/tasks/' + payload.task + '/risks/' + payload.risk + '/preventions/' + payload)
         .then((response) => {
           resolve(response.data);
         })
         .catch((error) => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
